package com.wintermar.inspection.feature.domain.model.answer

data class AnswerSelectionModel(
    val id: String = "",
    val answerId: String = "",
    val answerSelectionId: String = "",
    val answerSelectionValue: String = ""
)
